import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AnimatePresence, motion } from "framer-motion";
import { Route, Switch, useLocation } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Legal from "./pages/Legal";
import BlueprintSuccess from "./pages/BlueprintSuccess";
import BlueprintFulfillmentDesk from "./pages/BlueprintFulfillmentDesk";
import OperationsDashboard from "./pages/OperationsDashboard";
import AssessmentScheduler from "./pages/AssessmentScheduler";
import CoachApplication from "./pages/CoachApplication";
import CoachDirectory from "./pages/CoachDirectory";
import CoachOperations from "./pages/CoachOperations";
import CoachRequestAction from "./pages/CoachRequestAction";
import AuditLog from "./pages/AuditLog";
import SitePage from "./pages/SitePage";
import InsightArticle, { InsightIndex } from "./pages/InsightArticle";
import VendorApplication from "./pages/VendorApplication";
import VendorOperations from "./pages/VendorOperations";
import VendorPortal from "./pages/VendorPortal";
import FitLifeX, { FitLifeXLogin, FitLifeXWelcome } from "./pages/FitLifeX";
import FitLifeXPortal from "./pages/FitLifeXPortal";
import FitLifeOperations from "./pages/FitLifeOperations";
import ClientRegister from "./pages/ClientRegister";
import { ClientLogin, ClientSecure, ClientVerify } from "./pages/ClientAuth";
import ClientPortal from "./pages/ClientPortal";
import ClientOperations from "./pages/ClientOperations";

function Router() {
  const [location] = useLocation();
  return <AnimatePresence mode="wait"><motion.div className="route-transition" key={location} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -5 }} transition={{ duration: .24, ease: [0.23, 1, 0.32, 1] }}><Switch>
      <Route path="/" component={Home} />
      <Route path="/privacy" component={() => <Legal page="privacy" />} />
      <Route path="/terms" component={() => <Legal page="terms" />} />
      <Route path="/disclaimer" component={() => <Legal page="disclaimer" />} />
      <Route path="/blueprint-success" component={BlueprintSuccess} />
      <Route path="/operations" component={OperationsDashboard} />
      <Route path="/operations/blueprints" component={BlueprintFulfillmentDesk} />
      <Route path="/operations/vendors" component={VendorOperations} />
      <Route path="/operations/coaches" component={CoachOperations} />
      <Route path="/operations/audit" component={AuditLog} />
      <Route path="/operations/fitlife" component={FitLifeOperations} />
      <Route path="/operations/clients" component={ClientOperations} />
      {/* Ahead of the /:slug catch-all below, which would otherwise swallow
          every one of these and render a 404 page instead.

          The paid tier lives at /fitlife-x/pro, NOT /fitlife-x - that path is
          the existing free newsletter page (a SitePage slug, linked from the
          main nav) and taking it over would have quietly deleted the free
          newsletter the paid tier is meant to sit alongside. */}
      {/* Client portal. Ahead of /:slug like the rest. */}
      <Route path="/clients/register" component={ClientRegister} />
      <Route path="/clients/login" component={ClientLogin} />
      <Route path="/clients/secure" component={ClientSecure} />
      <Route path="/clients/verify" component={ClientVerify} />
      <Route path="/clients/portal" component={ClientPortal} />
      <Route path="/fitlife-x/pro" component={FitLifeX} />
      <Route path="/fitlife-x/login" component={FitLifeXLogin} />
      <Route path="/fitlife-x/welcome" component={FitLifeXWelcome} />
      <Route path="/fitlife-x/portal" component={FitLifeXPortal} />
      <Route path="/fitness-assessment" component={AssessmentScheduler} />
      <Route path="/partner-registration" component={VendorApplication} />
      <Route path="/vendor/access" component={VendorPortal} />
      <Route path="/coaches/apply" component={CoachApplication} />
      <Route path="/coach-request-action" component={CoachRequestAction} />
      <Route path="/coaches/:slug" component={CoachDirectory} />
      <Route path="/coaches" component={CoachDirectory} />
      <Route path="/insights" component={InsightIndex} />
      <Route path="/insights/:slug" component={InsightArticle} />
      <Route path="/:slug" component={SitePage} />
    </Switch></motion.div></AnimatePresence>;
}

export default function App() {
  return <ErrorBoundary><ThemeProvider defaultTheme="light"><TooltipProvider><Toaster richColors position="top-right" /><Router /></TooltipProvider></ThemeProvider></ErrorBoundary>;
}
